import { fromConsignmentResponse, toConsignmentRequest } from '../models/mapper'
import { ConsignmentSave } from '../models/request'
import { Consignment } from '../models/types'
import { createConsignmentDraftV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createConsignmentDraft(data: ConsignmentSave): Promise<Consignment> {
  const response = await createConsignmentDraftV2(toConsignmentRequest(data))
  return fromConsignmentResponse(response)
}
